import { ModelContext } from './ModelContext';
import { cartV2 } from '@wix/ecom';

export class PriceModel {
  public amount?: string;

  constructor(priceModel: PriceModel) {
    this.amount = priceModel.amount;
  }

  public static fromV2(
    price: cartV2.ConvertedMoney | undefined,
    { useConvertedPrices }: ModelContext,
  ) {
    if (!price) {
      return undefined;
    }
    return new PriceModel({
      amount: useConvertedPrices ? price?.convertedAmount : price?.amount,
    });
  }
}
